import { HTTP_TOKEN } from "./http";

export const getAutomation = (automation_id) => {
  return HTTP_TOKEN.get(`automation/${automation_id}`).then((result) => {
    return result.data;
  });
};


export const getAutomations = (params) => {
  return HTTP_TOKEN.get("automation", { params }).then((result) => {
    return result.data;
  });
};

export const createAutomation = (data) => {
  return HTTP_TOKEN.post("automation", data).then((result) => {
    return result.data;
  });
};


export const updateAutomation = (automation_id, data) => {
  return HTTP_TOKEN.put(`automation/${automation_id}`, data).then((result) => {
    return result.data;
  });
};

export const removeAutomation = (automation_id) => {
  return HTTP_TOKEN.delete(`automation/${automation_id}`).then((result) => {
    return result.data;
  });
};

export const getAutomationContactReport = (automation_id) => {
  return HTTP_TOKEN.get(`automation/${automation_id}/report`).then((result) => {
    return result.data;
  });
};


export const duplicateAutomation = (automation_id) => {
  return HTTP_TOKEN.post(`automation/${automation_id}/duplicate`).then((result) => {
    return result.data;
  });
};